import * as React from 'react';
import FileCell from './fileCell';
import Date from '../getDate';

export default class FileGroup extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const { data } = this.props;
        return (
            <div className="fileListingGroup detailListingGroup">

                <div className="date"><Date inputDate={data} /></div>
                {data.data.map((d) => {
                    return <React.Fragment key={d.id}><FileCell data={d.data} onItemClick={this.props.onItemClick} onCellClick={this.props.onCellClick} extraData={this.props.extraData}/></React.Fragment>
                })}
            </div>
        );
    }
}